import { gcApi } from 'config/axios';

export const postDeviceMessageViewed = (message) => {
    return gcApi.post('/device-service/devicemessage/messages', message);
};
